import { getConfig } from '../../../utils/config';

const { auth0Domain, auth0ClientId } = getConfig();
export function requestPasswordChange(email: string | undefined) {
  if (!email) {
    return;
  }
  return fetch(`https://${auth0Domain}/dbconnections/change_password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_id: auth0ClientId,
      email: email,
      connection: 'Username-Password-Authentication',
    }),
  });
}
